import React, { useContext, useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./ClusteredColumnsChart.scss";
import { formatNumber } from "../../../utils/format";
import { AppContext } from "../../../context/Context";

const ClusteredColumnsChart = ({ data }) => {
  // Get the highest value from both budget and actual

  const [active, setActive] = useState();

  const maxYValue = Math.max(
    ...data.flatMap((item) => [item.budget, item.actual])
  );

  const { dataRange, clearState } = useContext(AppContext);

  // Round up to the nearest 10M
  const roundedMax = Math.ceil(maxYValue / 10000000) * 10000000;

  const formatYAxis = (value) => {
    if (value === 0) return "$0M";
    return `$${(value / 1000000).toFixed(0)}M`;
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="tooltip">
          <div className="tooltip-title">{label}</div>
          <div className="tooltip-row">
            <span className="revenue-label">Total Budget:</span> $
            {formatNumber(payload[0].value)}
          </div>
          <div className="tooltip-row">
            <span className="costs-label">Total Actual COGS & Expenses:</span> $
            {formatNumber(payload[1].value)}
          </div>
        </div>
      );
    }
    return null;
  };

  useEffect(() => {
    if (dataRange === "All") {
      if (clearState === "") {
        setActive(true);
        // console.log("testtrue");
      } else if (clearState === null) {
        // console.log("run else if");

        setTimeout(() => {
          setActive(true);
        }, 950);
      } else {
        setActive(false);
        // console.log("testtrue");
      }
    } else {
      if (clearState !== "") {
        setTimeout(() => {
          setActive(true);
        }, 950);
      }
    }
  }, [setActive, dataRange, clearState]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{ top: 40, right: 30, left: 20, bottom: 5 }}
        barGap={8}
        barSize={38}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="month"
          tickMargin={20}
          axisLine={{ stroke: "#e0e0e0" }}
          style={{ fontSize: "13px" }}
        />
        <YAxis
          tickFormatter={formatYAxis}
          axisLine={{ stroke: "#e0e0e0" }}
          domain={[0, roundedMax]}
        />
        <Tooltip content={<CustomTooltip />} cursor={false} />
        <Legend
          verticalAlign="top"
          align="center"
          wrapperStyle={{ paddingBottom: 50 }}
        />
        <Bar
          dataKey="budget"
          name="Total Budget"
          fill="#4FD1C5"
          radius={[4, 4, 0, 0]}
          cursor="pointer"
          // label={{
          //   position: "top",
          //   formatter: (value) => `$${(value / 1000000).toFixed(1)}M`,
          //   fontSize: 13,
          // }}
          isAnimationActive={active === true ? true : false}
          animateNewValues={active === true ? true : false}
        />
        <Bar
          dataKey="actual"
          name="Total Actual COGS & Expenses By Month"
          fill="#90CDF4"
          radius={[4, 4, 0, 0]}
          cursor="pointer"
          // label={{
          //   position: "top",
          //   formatter: (value) => `$${(value / 1000000).toFixed(1)}M`,
          //   fontSize: 13,
          // }}
          isAnimationActive={active === true ? true : false}
          animateNewValues={active === true ? true : false}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ClusteredColumnsChart;
